import classNames from 'classnames';
import { useEffect, useState } from 'react';
import styles from './AddAccount.module.scss';
import { Signature } from 'components/Signutare/Signature';
import { useNavigate } from 'react-router-dom';
import { AllRoutes } from 'constants/routes';
import axiosInst from 'api/axios';
import { TextAreaWithAutocomplete } from 'components/TextAreaWithAutocomplete/TextAreaWithAutocomplete';

const IVA = 21;

export const AddAccount = () => {
  const navigate = useNavigate();
  const [num, setNum] = useState('');

  const [date, setDate] = useState(new Date().toISOString().substring(0, 10));
  const [client, setClient] = useState('');
  const [address, setAddress] = useState('');
  const [postal, setPostal] = useState('');
  const [dni, setDni] = useState('');
  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');

  const [tableData, setTableData] = useState([
    { name: '', price: '', total: '' },
    { name: '', price: '', total: '' },
  ]);

  const [subtotal, setSubtotal] = useState('');
  const [iva, setIva] = useState('');
  const [total, setTotal] = useState();

  const [aparat, setAparat] = useState('');
  const [model, setModel] = useState('');
  const [brand, setBrand] = useState('');
  const [serie, setSerie] = useState('');

  const [mano, setMano] = useState('');
  const [material, setMaterial] = useState('');

  const [sigUrl1, setSifUrl1] = useState(null);
  const [sigUrl2, setSifUrl2] = useState(null);
  const [sigUrl3, setSifUrl3] = useState(null);

  const year = new Date().getFullYear().toString();

  const handleSave = async () => {
    axiosInst()
      .post('/accounts', {
        number: Number(num),
        name: client,
        date,
        address,
        postal,
        dni,
        email,
        tel,
        tableData: tableData.filter(({ name, price, total }) => name || price || total),
        subtotal,
        iva,
        total,
        aparat,
        model,
        brand,
        serie,
        mano,
        material,
        year,
        signatureFirst: sigUrl1,
        signatureSecond: sigUrl2,
        signatureThird: sigUrl3,
      })
      .then(() => {
        navigate(AllRoutes.home);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const textareas = document.getElementsByTagName('textarea');

  for (let textarea of textareas) {
    textarea.addEventListener('keydown', autosize);
  }

  function autosize() {
    var el = this;
    setTimeout(function () {
      el.style.cssText = 'height:auto; padding:0';
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
    }, 0);
  }

  useEffect(() => {
    axiosInst()
      .get('/accounts/number')
      .then((res) => setNum(res.data));
  }, []);

  useEffect(() => {
    if (tableData.length > 1) {
      if (
        tableData[tableData.length - 1].name ||
        tableData[tableData.length - 1].price ||
        tableData[tableData.length - 1].total
      ) {
        setTableData([...tableData, { name: '', price: '', total: '' }]);
      }
    }
    if (tableData.length > 2) {
      if (
        !tableData[tableData.length - 1].name &&
        !tableData[tableData.length - 1].price &&
        !tableData[tableData.length - 1].total &&
        !tableData[tableData.length - 2].name &&
        !tableData[tableData.length - 2].price &&
        !tableData[tableData.length - 2].total
      ) {
        setTableData(tableData.slice(0, -1));
      }
    }
  }, [tableData]);

  useEffect(() => {
    const sub = tableData.reduce((acc, curr) => {
      return acc + (Number(curr.total) || 0);
    }, 0);
    setSubtotal(sub.toFixed(2));
    const percent = (sub * IVA) / 100;
    setIva(percent.toFixed(2));
    setTotal((percent + sub).toFixed(2));
  }, [tableData]);

  return (
    <>
      <div className={styles.container}>
        {/* <button
          className={styles.back}
          onClick={() => {
            navigate(AllRoutes.home);
          }}
        >
          ⇦
        </button> */}
        <div className={styles.personalInfo}>
          <div className={classNames(styles.flex, styles.firstLine)}>
            <div className={classNames(styles.flex, styles.line)}>
              <label>№ Albarán</label>
              <input
                readOnly
                type='number'
                value={`${year}${('000' + num).slice(-4)}`}
                onChange={(e) => setNum(e.target.value)}
              />
            </div>
            <div className={classNames(styles.flex, styles.line)}>
              <label>Fecha</label>
              <input type='date' value={date} onChange={(e) => setDate(e.target.value)} />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={classNames(styles.flex, styles.line)}>
              <label>Cliente</label>
              <input type='text' value={client} onChange={(e) => setClient(e.target.value)} />
            </div>
            <div className={classNames(styles.flex, styles.line)}>
              {' '}
              <label>D.N.I.</label>
              <input type='text' value={dni} onChange={(e) => setDni(e.target.value)} />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={classNames(styles.flex, styles.line)}>
              {' '}
              <label>Dirección</label>
              <input type='text' value={address} onChange={(e) => setAddress(e.target.value)} />
            </div>
            <div className={classNames(styles.flex, styles.line)}>
              {' '}
              <label>Postal</label>
              <input type='text' value={postal} onChange={(e) => setPostal(e.target.value)} />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={classNames(styles.flex, styles.line)}>
              <label>E-mail</label>
              <input type='email' value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className={classNames(styles.flex, styles.line)}>
              {' '}
              <label>Tel.</label>
              <input type='tel' value={tel} onChange={(e) => setTel(e.target.value)} />
            </div>
          </div>
        </div>
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead className={styles.tableHead}>
              <tr>
                <th>Concepto</th>
                <th>Unidad</th>
                <th>Precio total</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map(({ name, price, total }, i) => (
                <tr key={'line' + i}>
                  <td>
                    <TextAreaWithAutocomplete name={name} tableData={tableData} setTableData={setTableData} i={i} />
                  </td>
                  <td>
                    <input
                      className={styles.tableInput}
                      type='number'
                      value={price}
                      placeholder={name && 1}
                      onChange={(e) =>
                        setTableData((prev) =>
                          prev.map((item, index) => (i === index ? { ...item, price: e.target.value } : item)),
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      className={styles.tableInput}
                      type='number'
                      value={total}
                      placeholder={name && '0.00'}
                      onChange={(e) =>
                        setTableData((prev) =>
                          prev.map((item, index) => (i === index ? { ...item, total: e.target.value } : item)),
                        )
                      }
                      onBlur={() =>
                        total &&
                        setTableData((prev) =>
                          prev.map((it, index) => (index === i ? { ...it, total: Number(it.total).toFixed(2) } : it)),
                        )
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className={styles.tableSummary}>
            <div>
              <label>Subtotal</label>
              <div className={styles.summaryInpCell}>
                <input readOnly type='number' value={subtotal || ''} onChange={(e) => setSubtotal(e.target.value)} />
              </div>
            </div>
            <div>
              <label>21% I.V.A.</label>
              <div className={styles.summaryInpCell}>
                <input readOnly type='number' value={iva || ''} onChange={(e) => setIva(e.target.value)} />
              </div>
            </div>
            <div className={styles.total}>
              <label>Total</label>
              <div className={styles.summaryInpCell}>
                <input readOnly type='number' value={total || ''} onChange={(e) => setTotal(e.target.value)} />
              </div>
            </div>
          </div>
        </div>{' '}
        <div className={styles.aparatInfo}>
          <div className={classNames(styles.flex)}>
            <label>Aparato</label>
            <textarea rows={1} className={styles.textarea} value={aparat} onChange={(e) => setAparat(e.target.value)} />
          </div>
          <div className={classNames(styles.flex)}>
            <label>Marca</label>
            <textarea rows={1} className={styles.textarea} value={brand} onChange={(e) => setBrand(e.target.value)} />
          </div>
          <div className={classNames(styles.flex)}>
            <label>Modelo</label>
            <textarea rows={1} className={styles.textarea} value={model} onChange={(e) => setModel(e.target.value)} />
          </div>
          <div className={classNames(styles.flex)}>
            <label>№ Serie</label>
            <textarea rows={1} className={styles.textarea} value={serie} onChange={(e) => setSerie(e.target.value)} />
          </div>
        </div>
        <div className={styles.signutares}>
          <div>
            <span>Firma</span>
            <Signature sigUrl={sigUrl1} setSigUrl={setSifUrl1} />
          </div>
          <div>
            <span>Visto bueno al presupuesto</span>
            <div className={classNames(styles.flex, styles.line)}>
              <label>Mano de obra</label>
              <input type='number' value={mano} onChange={(e) => setMano(e.target.value)} />
            </div>
            <div className={classNames(styles.flex, styles.line)}>
              {' '}
              <label>Material</label>
              <input type='text' value={material} onChange={(e) => setMaterial(e.target.value)} />
            </div>

            <Signature sigUrl={sigUrl2} setSigUrl={setSifUrl2} />
          </div>
          <div>
            <span>He recibido la cantidad de:</span>
            <Signature sigUrl={sigUrl3} setSigUrl={setSifUrl3} />
          </div>
        </div>
        <p className={styles.rights}>
          Condiciones de garantia: las reparaciones e instalaciones realizadas tienen una garantia de 3 meses en los
          términos establecidos en el articulo 11 de la Ley General para la defensa de los consumidores. Quedan
          excluidos de la garantía aquellos trabajos en la que haya existido manipulación posterior por parte de
          personal ajeno a esta empresa, así como los problemas derivados de mal uso de los elementos que son objeto de
          esta garantia. Los trabajos de desatascos, virus y configuraciones informáticas yaperturas, tienen limitada la
          garantia en función de su naturaleza. Existen hojas de reclamación del cliente.
        </p>
        <button onClick={handleSave} className={classNames(styles.saveBtn, 'btn')}>
          save
        </button>
      </div>
    </>
  );
};
